import { CONTENT_WRAPPER_ID } from '../../../constants/elements';

const WAIT_TIMEOUT = 200;

/**
 * Находится ли элемент на другой позиции относительно верха страницы с учетом скролла.
 */
export function waitForPageOffsetChange(element: HTMLElement, initialPageOffset: number): Promise<boolean> {
  return new Promise(resolve => {
    // eslint-disable-next-line prefer-const
    let timeoutId: number;

    const contentWrapper = document.getElementById(CONTENT_WRAPPER_ID);

    if (!contentWrapper) {
      resolve(false);

      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      const newPageOffset = window.scrollY + element.getBoundingClientRect().top;

      if (initialPageOffset !== newPageOffset) {
        resizeObserver.disconnect();
        window.clearTimeout(timeoutId);
        resolve(true);
      }
    });

    resizeObserver.observe(contentWrapper);

    timeoutId = window.setTimeout(() => {
      resizeObserver.disconnect();
      resolve(false);
    }, WAIT_TIMEOUT);
  });
}
